import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { enqueueSnackbar } from 'notistack';

import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { MutationStateFns } from '@/api/utils/mutation';
import { useAuth } from '@/context/AuthProvider';

export type ApiResponse_StoreManagerResponseTo_Sms = {
  session_id: string;
};

export type ApiRequest_StoreManagerResponseTo_Sms = {
  sessionId: string;
  message: string;
  propertyId: string;
  title?: string;
};

const METHOD = 'POST';
const ENDPOINT = 'twilio/manager-response';

export const useStoreManagerResponseToSms = (
  stateFns?: MutationStateFns<ApiResponse_StoreManagerResponseTo_Sms>
) => {
  const { session } = useAuth();

  return useMutation({
    mutationFn: async (data: ApiRequest_StoreManagerResponseTo_Sms) =>
      handleApiCall<ApiResponse_StoreManagerResponseTo_Sms, ApiRequest_StoreManagerResponseTo_Sms>(
        session,
        METHOD,
        getResolvedEndpoint(ENDPOINT, {}),
        data
      ),
    onSuccess: data => {
      enqueueSnackbar('Manager response stored successfully', { variant: 'success' });

      stateFns?.onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      enqueueSnackbar('Failed to store manager response', { variant: 'error' });

      // eslint-disable-next-line no-console
      console.error(err);
      stateFns?.onError?.(err);
    },
  });
};
